import { useEffect } from 'react';
import Storage from 'utilities/storage';
import { doTagInvalidProduct } from 'components/newAccountSteps/initialStep/tagging';

export const useGetDefaultProducts = ({ getOnboardingService, isJointHolder }, getProductsServiceAction) => {
    useEffect(() => {
        const getDefaultProducts = () => {
            const cookie = Storage.cookies.get('accessToken');
            if (cookie && !getOnboardingService) return;
            if (!isJointHolder) {
                getProductsServiceAction((valid, error) => {
                    if (!valid) {
                        doTagInvalidProduct(error);
                    }
                });
            }
        };
        getDefaultProducts();
    }, [getOnboardingService]);
};
